import { createAction, props } from '@ngrx/store';
import { AdvancedSearchModel, SortEvent } from 'mbs-ui-kit';
import { ScriptLibraryEntry, ScriptLibraryTag, ScriptLibraryTransfer } from './model';

import { Update } from '@ngrx/entity';
import { StoreTypes } from 'mbs-ui-shared@store/storeTypes.enum';

export const catchError = createAction(`[${StoreTypes.RmmScriptLibrary}] Error`, props<{ error: any }>());
export const registerScript = createAction(`${StoreTypes.RmmScriptLibrary} Register Script`, props<{ transfer: ScriptLibraryTransfer }>());
export const updateScript = createAction(
  `${StoreTypes.RmmScriptLibrary} Update Script`,
  props<{ id: ScriptLibraryEntry['id']; transfer: ScriptLibraryTransfer }>()
);
export const callEditor = createAction(`${StoreTypes.RmmScriptLibrary} Call Scripts Editor`, props<{ id: ScriptLibraryEntry['id'] }>());

export const deleteScript = createAction(`${StoreTypes.RmmScriptLibrary} Delete Script`, props<{ id: ScriptLibraryEntry['id'] }>());

export const sortScriptsInLibrary = createAction(`${StoreTypes.RmmScriptLibrary} Sort Scripts in Library`, props<{ sort: SortEvent }>());
export const filterScriptsInLibrary = createAction(
  `${StoreTypes.RmmScriptLibrary} Filter Scripts in Library`,
  props<{ filters: AdvancedSearchModel }>()
);

export const loadScriptsInLibrary = createAction(`${StoreTypes.RmmScriptLibrary} Load Scripts in Library`);
export const loadScriptBody = createAction(`${StoreTypes.RmmScriptLibrary} Load Script Body`, props<{ scriptGuid: string }>());
export const addScripIntLibrary = createAction(
  `${StoreTypes.RmmScriptLibrary} Add Script in Library`,
  props<{ script: ScriptLibraryEntry }>()
);

export const upsertScriptInLibrary = createAction(
  `${StoreTypes.RmmScriptLibrary} Upsert Script in Library`,
  props<{ script: ScriptLibraryEntry }>()
);
export const upsertScriptBody = createAction(
  `${StoreTypes.RmmScriptLibrary} Upsert Script Body`,
  props<{ body: ScriptLibraryEntry['body']; scriptGuid: string }>()
);

export const addScriptsInLibrary = createAction(
  `${StoreTypes.RmmScriptLibrary} Add Scripts in Library`,
  props<{ scripts: ScriptLibraryEntry[] }>()
);

export const loadTags = createAction(`${StoreTypes.RmmScriptLibrary} Load Tags`);
export const addTag = createAction(`${StoreTypes.RmmScriptLibrary} Add Tag`, props<{ tag: ScriptLibraryTag }>());
export const upsertTags = createAction(`${StoreTypes.RmmScriptLibrary} Upsert Tags`, props<{ tags: ScriptLibraryTag[] }>());
export const registerTag = createAction(`${StoreTypes.RmmScriptLibrary} Register Tag`, props<{ tagName: string }>());
export const deleteTag = createAction(`${StoreTypes.RmmScriptLibrary} Delete Tag`, props<{ tagGuid: string }>());

export const upsertScripsInLibrary = createAction(
  `${StoreTypes.RmmScriptLibrary} Upsert Scripts in Library`,
  props<{ scripts: ScriptLibraryEntry[] }>()
);

export const updateScriptLibrary = createAction(
  `${StoreTypes.RmmScriptLibrary} Update Script in Library`,
  props<{ script: Update<ScriptLibraryEntry> }>()
);

export const updateScriptsInLibrary = createAction(
  `${StoreTypes.RmmScriptLibrary} Update Scripts in Library`,
  props<{ scripts: Update<ScriptLibraryEntry>[] }>()
);

export const deleteScriptInLibrary = createAction(`${StoreTypes.RmmScriptLibrary} Delete Script in Library`, props<{ id: string }>());
export const deleteTagInLibrary = createAction(`${StoreTypes.RmmScriptLibrary} Delete Tag in Library`, props<{ tagGuid: string }>());

export const deleteScriptsInLibrary = createAction(`${StoreTypes.RmmScriptLibrary} Delete Scripts in Library`, props<{ ids: string[] }>());
export const clearFilters = createAction(`${StoreTypes.RmmScriptLibrary} Clear Filters`);
export const clearScriptLibrary = createAction(`${StoreTypes.RmmScriptLibrary} Clear Library`);
